import { capitalize, slugify } from '../../src/utils/string/index.ts'
import { pxToRem } from './utils.mjs'
/**
 * @enum {number}
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1920
}

export const colors = {
  black: '#000',
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    DEFAULT: '#00F'
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
    DEFAULT: '#75F348'
  },
  grey: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
    DEFAULT: '#9A9EAC',
    dark: '#3E3F45',
    darker: '#2E2F34',
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    DEFAULT: '#F00'
  },
  white: '#FFF'
}

/**
 * Default app fonts.
 *
 * The proerty `alternativeName` is optional and will be used as the font name in the CSS.
 * If not provided, the `name` property will be used.
 * The property `path` is relative to `@src/assets/fonts/` folder
 */
export const fonts = [
  // { alternativeName: undefined, name: 'Font name', path: 'foo/bar', weight: 100-900 },
]

/**
 * Format fonts for UnoCSS.
 *
 * Your fonts will become a slugified version of the `name` with `font` prefix.
 *
 * @example Roboto -> font-roboto
 */
export const formatFonts = (_fonts = fonts) => {
  return _fonts.reduce((acc, font) => {
    const name = font.alternativeName || font.name
    acc[slugify(name)] = name
    return acc
  }, {})
}

const breakpointsEntries = Object.entries(breakpoints)
/**
 * @typedef {{[k in keyof typeof breakpoints as `at${Capitalize<k>}`]: {min?: string, max?: string}}} OnlyValues
 * @typedef {{[k in keyof typeof breakpoints as `lt${Capitalize<k>}`]: {min?: string, max?: string}}} BeforeValues
 * @typedef {{[k in keyof typeof breakpoints]: string}} Values
 *
 * @typedef {OnlyValues & BeforeValues & Values} Breakpoints
 *
 * @type {Breakpoints}
 */
// @ts-expect-error we are building this object
export const screens = breakpointsEntries.reduce((acc, [name, value], i) => {
  const nextBreakpoint = breakpointsEntries[i + 1]
  acc[name] = pxToRem(value)
  acc[`at${capitalize(name)}`] = nextBreakpoint
    ? { min: pxToRem(value), max: pxToRem(nextBreakpoint[1] - 1) }
    : { min: pxToRem(value) }

  acc[`lt${capitalize(name)}`] = { max: pxToRem(value - 1) }
  return acc
}, {})

export default {
  breakpoints: breakpointsEntries.reduce((acc, [name, value], i) => {
    acc[name] = pxToRem(value)
    return acc
  }, {}),
  colors,
  fontFamily: formatFonts()
}
